import React from "react";
import Contact from "@/components/Contact";

export default function ContactPage() {
  return (
    <main className="pt-24 sm:pt-28">
      <Contact />
    </main>
  );
}
